import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__ from "../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__ from "../../variants/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__ from "../../variants/tv.js";
const labelVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__.tv)({
    extend: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.textVariants
});
function Label({ children, className, ...restProps }) {
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)(labelVariants(restProps), className);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("label", {
        className: classes,
        ...(0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cleanProps)(restProps, [
            ...__WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.textVariantsFields
        ]),
        children: children
    });
}
export { Label };
